import AppForm from '@/components/Form/Form.vue';
import AppFormError from '@/components/Form/Error.vue';
import AppFormInput from '@/components/Form/Input.vue';
import AppFormLabel from '@/components/Form/Label.vue';
import AppFormHelpText from '@/components/Form/HelpText.vue';
import AppFormTextarea from '@/components/Form/Textarea.vue';
import AppFormFilePicker from '@/components/Form/FilePicker.vue';
import AppAttachmentProgress from '@/components/Form/Views/AttachmentProgress.vue';
import AppFormSelect from '@/components/Form/Select.vue';
import AppFormSwitch from '@/components/Form/Switch.vue';
import AppFormAvatar from '@/components/Form/Avatar.vue';
import AppFormSubmit from '@/components/Form/Submit.vue';
import AppFormGrid from '@/components/Form/Layouts/Grid.vue';
import AppFormFileUpload from '@/components/Form/FileUpload.vue';
import AppFormHidden from '@/components/Form/Hidden.vue';

export default {
    AppForm,
    AppFormError,
    AppFormLabel,
    AppFormHelpText,
    AppFormInput,
    AppFormTextarea,
    AppFormFilePicker,
    AppAttachmentProgress,
    AppFormSelect,
    AppFormSwitch,
    AppFormAvatar,
    AppFormSubmit,
    AppFormGrid,
    AppFormFileUpload,
    AppFormHidden,
}
